<template>
  <!-- TODO Move getIcon and internal SVG into VUE template -->
  <div>
    <img :src="defaultImage">
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'getDatasetKey',
    ]),
    defaultImage () {
      return '/api/dataset/' + this.getDatasetKey + '/logo.svg'
    }
  }
}
</script>
